module.exports = __webpack_public_path__ + "static/img/turntable-front.e2cc5fb5.png";